import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WebsiteEnquiryService } from 'src/app/services/Enquiry/WebsiteEnquiry.Service';
/* Start Contact Method Model Section */

interface EcbContactMethodDetail {
  label: string;
  text: string;
  link?: string;
}

interface EcbContactMethod {
  id: number;
  title: string;
  icon: string;
  colorClass: string;
  details: EcbContactMethodDetail[];
  footer?: string;
}
/* End Contact Method Model Section */


/* Start Contact Office Model Section */
interface EcbContactOffice {
  id: number;
  name: string;
  addressLineOne: string;
  addressLineTwo: string;
  phone: string;
  image: string;
  email: string;
  openHourse: string
}
/* End Contact Office Model Section */


/* Start Contact Subject Model Section */
interface EcbContactSubject {
  id: number;
  name: string;
}
/* End Contact Subject Model Section */


/* Start Contact Form Model Section */
interface EcbContactForm {
  fullName: string;
  emailAddress: string;
  phoneNumber: string;
  subject: string;
  message: string;
}
/* End Contact Form Model Section */


/* Start Frequently Asked Question Model Section */
interface EcbContactFaq {
  id: number;
  question: string;
  answer: string;
}
/* End Frequently Asked Question Model Section */
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {


  /* Start Property Declaration Section */
  public contactMethods: EcbContactMethod[] = [];
  public contactOffices: EcbContactOffice[] = [];
  public contactSubjects: EcbContactSubject[] = [];
  public frequentlyAskedQuestions: EcbContactFaq[] = [];

  public contactForm: EcbContactForm = {
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    subject: '',
    message: ''
  };

  public expandedFaqId: number | null = null;
  public isCaptchaConfirmed: boolean = false;
  public isContactSending: boolean = false;
  public isContactSuccess: boolean = false;
  public isContactError: boolean = false;
  /* End Property Declaration Section */


  /* Start Constructor Section */
  constructor(private websiteEnquiryService: WebsiteEnquiryService, private route: ActivatedRoute) {

  }
  /* End Constructor Section */


  /* Start Component Initialization Section */
  ngOnInit(): void {


    this.getContactMethods();
    this.getContactOffices();
    this.getContactSubjects();
    this.getFrequentlyAskedQuestions();
    const course = this.route.snapshot.queryParamMap.get('course');
    const code = this.route.snapshot.queryParamMap.get('courseCode');
    if (course) {
      this.contactForm.subject = 'Course Enquiry';
      this.contactForm.message = 'I would like to know more about ' + (code ? code + ' — ' : '') + course + '.';
    }
  }
  /* End Component Initialization Section */


  ngAfterViewInit(): void {

    const type = this.route.snapshot.queryParamMap.get('type');

    if (type?.toLowerCase() === 'location') {

      requestAnimationFrame(() => {

        const section = document.getElementById('course-enquiry');

        if (section) {

          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }

      });

    }

  }


  /* Start Contact Method Static List Section */

  /* Start Contact Method Static List Section */
  getContactMethods(): void {
    this.contactMethods = [
      {
        id: 1,
        title: 'Call Us',
        icon: 'bi bi-telephone-fill',
        colorClass: 'ecb-web-contact-method-blue',
        details: [
          {
            label: 'Victoria',
            text: '1300 322 486',
            link: 'tel:1300322486'
          },
          {
            label: 'Northern Territory',
            text: '08 7905 4026',
            link: 'tel:0879054026'
          }
        ]
      },
      {
        id: 2,
        title: 'Email Us',
        icon: 'bi bi-envelope',
        colorClass: 'ecb-web-contact-method-orange',
        details: [
          {
            label: 'Victoria',
            text: 'melbourne@ecbtraining.com.au',
            link: 'mailto:melbourne@ecbtraining.com.au'
          },
          {
            label: 'Northern Territory',
            text: 'darwin@ecbtraining.com.au',
            link: 'mailto:darwin@ecbtraining.com.au'
          }
        ]
      },
      {
        id: 3,
        title: 'Business Hours',
        icon: 'bi bi-clock',
        colorClass: 'ecb-web-contact-method-purple',
        details: [
          {
            label: 'Victoria',
            text: 'Mon - Fri: 07:00 - 16:30'
          },
          {
            label: 'Northern Territory',
            text: 'Mon - Fri: 07:30 - 16:30'
          }
        ],
        footer: 'Saturday & Sunday by appointment'
      },
      {
        id: 4,
        title: 'Visit Us',
        icon: 'bi bi-geo-alt-fill',
        colorClass: 'ecb-web-contact-method-teal',
        details: [
          {
            label: 'Victoria',
            text: '598 Kororoit Creek Road, Altona North, VIC 3025'
          },
          {
            label: 'Northern Territory',
            text: '44 McMinn Street, Darwin, NT 0800'
          }
        ]
      },
      {
        id: 5,
        title: 'Online Chat',
        icon: 'bi bi-chat-dots-fill',
        colorClass: 'ecb-web-contact-method-teal',
        details: [
          {
            label: 'Live Chat Support',
            text: 'Available soon'
          }
        ],
        footer: ''
      }

    ];
  }
  /* End Contact Method Static List Section */

  /* End Contact Method Static List Section */


  /* Start Contact Office Static List Section */
  getContactOffices(): void {
    this.contactOffices = [
      {
        id: 1,
        name: 'Victoria',
        addressLineOne: '598 Kororoit Creek Road,',
        addressLineTwo: 'Altona North, VIC 3025',
        phone: '1300 322 486​',
        image: 'assets/images/locations/contact_melbourne.png',
        email: 'melbourne@ecbtraining.com.au',
        openHourse: '07:00 – 16:30 Monday to Friday, Saturday and Sunday by appointment'
      },
      {
        id: 2,
        name: 'Northern Territory',
        addressLineOne: '44 McMinn Street, ​',
        addressLineTwo: 'Darwin, NT 0800',
        phone: '08 7905 4026​',
        image: 'assets/images/locations/contact_brisbane.png',
        email: 'darwin@ecbtraining.com.au',
        openHourse: '07:00 – 16:30 Monday to Friday, Saturday and Sunday by appointment'
      }
    ];
  }
  /* End Contact Office Static List Section */


  /* Start Contact Subject Static List Section */
  getContactSubjects(): void {
    this.contactSubjects = [
      {
        id: 1,
        name: 'Course Enquiry'
      },
      {
        id: 2,
        name: 'Course Booking'
      },
      {
        id: 3,
        name: 'Corporate Training'
      },
      {
        id: 4,
        name: 'Payment Enquiry'
      },
      {
        id: 5,
        name: 'Certificate Enquiry'
      },
      {
        id: 6,
        name: 'General Enquiry'
      }
    ];
  }
  /* End Contact Subject Static List Section */


  /* Start Frequently Asked Question Static List Section */
  getFrequentlyAskedQuestions(): void {
    this.frequentlyAskedQuestions = [
      {
        id: 1,
        question: 'How do I enrol in a course?',
        answer:
          'Choose your preferred course, select an available training date and complete the online enrolment form. Our team will then confirm your booking.'
      },
      {
        id: 2,
        question: 'Can I pay in instalments?',
        answer:
          'Payment options may vary depending on the selected course. Contact our team to discuss the payment methods available for your booking.'
      },
      {
        id: 3,
        question: 'Do you offer group or corporate training?',
        answer:
          'Yes. We provide customised onsite, online and classroom training programs for businesses and larger groups.'
      },
      {
        id: 4,
        question: 'What is your refund policy?',
        answer:
          'Refund eligibility depends on the cancellation date and the applicable course terms. Review the refund policy or contact our support team for assistance.'
      }
    ];
  }
  /* End Frequently Asked Question Static List Section */


  /* Start Contact Form Submission Function Section */
  submitContactForm(): void {

    if (
      !this.contactForm.fullName.trim() ||
      !this.contactForm.emailAddress.trim() ||
      !this.contactForm.phoneNumber.trim() ||
      !this.contactForm.subject.trim() ||
      !this.contactForm.message.trim()

    ) {

      this.isContactError = true;
      this.isContactSuccess = false;

      setTimeout(() => {
        this.isContactError = false;
      }, 5000);

      return;
    }


    if (this.isContactSending) {
      return;
    }


    this.isContactSending = true;
    this.isContactSuccess = false;
    this.isContactError = false;


    this.websiteEnquiryService
      .submitContactForm(
        this.contactForm
      )
      .subscribe({

        next: () => {

          this.isContactSending = false;
          this.isContactSuccess = true;

          this.resetContactForm();

          this.isCaptchaConfirmed = false;

          setTimeout(() => {
            this.isContactSuccess = false;
          }, 5000);

        },

        error: (error) => {

          this.isContactSending = false;
          this.isContactSuccess = false;
          this.isContactError = true;

          console.error(
            'Contact form submission failed:',
            error
          );

          setTimeout(() => {
            this.isContactError = false;
          }, 5000);

        }

      });
  }
  /* End Contact Form Submission Function Section */


  /* Start Contact Form Reset Function Section */
  resetContactForm(): void {
    this.contactForm = {
      fullName: '',
      emailAddress: '',
      phoneNumber: '',
      subject: '',
      message: ''
    };

    this.isCaptchaConfirmed = false;
  }
  /* End Contact Form Reset Function Section */


  /* Start FAQ Toggle Function Section */
  toggleFaq(faqId: number): void {
    this.expandedFaqId =
      this.expandedFaqId === faqId
        ? null
        : faqId;
  }
  /* End FAQ Toggle Function Section */


  /* Start FAQ Open Status Function Section */
  isFaqOpen(faqId: number): boolean {
    return this.expandedFaqId === faqId;
  }
  /* End FAQ Open Status Function Section */


  /* Start Track By Function Section */
  trackById(index: number, item: { id: number }): number {
    return item.id;
  }
  /* End Track By Function Section */

}
